import { render, staticRenderFns } from "./ParsingOverviewPage.vue?vue&type=template&id=4e97efef"
import script from "./ParsingOverviewPage.vue?vue&type=script&lang=js"
export * from "./ParsingOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports